import { Environment } from '@/environments/environment.type';

export const environment: Environment = {
  // production: false,
  baseUrlImg: '/media/images',
  baseUrlVideo: '/media/videos',
  baseUrlLogo: '/media/logos',
  cognito: {
    userPoolId: 'eu-west-2_v5j1r7XmF',
    userPoolClientId: '6j0aaggoee6v4462pjt47ulck6',
  },
  appSync: {
    amplifyEndpoint: 'https://icad7jny7fhr5k3ttm5g4gotiu.appsync-api.eu-west-2.amazonaws.com/graphql',
    region: 'eu-west-2',
  },
};
